<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon bg-mean-fruit rounded-circle"><i class="pe-7s-bell text-white"></i></div>
        <div>
          Live Activity
          <span class="live-pulse-badge"><span class="live-pulse-dot"></span>Live</span>
          <div class="page-title-subheading">Every production event as it happens, across all operators.</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Summary strip -->
  <div class="row">
    <div class="col-md-4">
      <div class="mb-2 card stat-card">
        <div class="stat-icon stat-icon-events"><i class="fa fa-bolt"></i></div>
        <div class="stat-body">
          <div class="stat-value">{{ entries.length }}</div>
          <div class="stat-label">Events Today</div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="mb-2 card stat-card">
        <div class="stat-icon stat-icon-products"><i class="fa fa-cube"></i></div>
        <div class="stat-body">
          <div class="stat-value">{{ activeProductCount }}</div>
          <div class="stat-label">Products Active</div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="mb-2 card stat-card">
        <div class="stat-icon stat-icon-time"><i class="fa fa-clock"></i></div>
        <div class="stat-body">
          <div class="stat-value stat-value-time">{{ lastUpdatedAt ? formatTime(lastUpdatedAt.toISOString()) : '—' }}</div>
          <div class="stat-label">Last Update</div>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-2 card" *ngIf="!loading && entries.length === 0">
    <div class="card-body text-center text-muted py-5">
      <i class="pe-7s-bell empty-state-icon"></i>
      <div>No activity yet today.</div>
    </div>
  </div>

  <ng-container *ngIf="entries.length > 0">
    <!-- Chronological feed of the most recent events, regardless of product -->
    <div class="dashboard-section-label">Latest Activity</div>
    <div class="mb-2 card">
      <ul class="live-feed-list live-feed-scroll">
        <li class="live-feed-row" *ngFor="let entry of latestEntries; let last = last">
          <div class="live-feed-rail">
            <div class="live-feed-icon" [class.mode-checkCount]="entry.mode === 'checkCount'" [class.mode-startEnd]="entry.mode === 'startEnd'">
              <i class="fa" [class.fa-check]="entry.mode === 'checkCount'" [class.fa-hourglass-end]="entry.mode === 'startEnd'"></i>
            </div>
            <div class="live-feed-connector" *ngIf="!last"></div>
          </div>
          <div class="live-feed-body">
            <div class="live-feed-main">
              <div class="live-feed-title">
                <strong>{{ entry.operatorName }}</strong> completed <strong>{{ entry.productName }}</strong>
                <span class="live-feed-step">{{ entry.stepName }}</span>
              </div>
              <span
                class="badge live-feed-mode-badge"
                [class.badge-success]="entry.mode === 'checkCount'"
                [class.badge-primary]="entry.mode === 'startEnd'"
              >
                {{ entry.mode | camelToTitle }}
              </span>
            </div>
            <div class="live-feed-meta">
              <span class="live-feed-relative">{{ relativeTime(entry.endTime || entry.createdAt) }}</span>
              <span class="dot-sep">&middot;</span>
              <span>{{ formatTime(entry.endTime || entry.createdAt) }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- Grouped by product/step for browsing the full picture -->
    <div class="dashboard-section-label">By Product</div>
    <div class="accordion" id="liveActivityAccordion">
      <div class="accordion-item" *ngFor="let product of groupedEntries(); let i = index; let first = first">
        <h2 class="accordion-header" [id]="'heading-' + i">
          <button
            class="accordion-button"
            [class.collapsed]="!first"
            type="button"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse-' + i"
            [attr.aria-expanded]="first"
            [attr.aria-controls]="'collapse-' + i"
          >
            <i class="pe-7s-box2 accordion-product-icon"></i>
            {{ product.productName }}
            <span class="badge badge-secondary ml-2">{{ product.totalCount }}</span>
          </button>
        </h2>
        <div
          [id]="'collapse-' + i"
          class="accordion-collapse collapse"
          [class.show]="first"
          [attr.aria-labelledby]="'heading-' + i"
          data-bs-parent="#liveActivityAccordion"
        >
          <div class="accordion-body p-0 accordion-body-scroll">
            <div class="step-block" *ngFor="let step of product.steps">
              <div class="step-block-header">
                <strong>{{ step.stepName }}</strong>
                <span class="badge badge-light">{{ step.entries.length }}</span>
              </div>
              <ul class="list-unstyled mb-0 step-entry-scroll">
                <li class="step-entry" *ngFor="let entry of step.entries">
                  <span class="step-entry-time">{{ formatTime(entry.endTime || entry.createdAt) }}</span>
                  — {{ entry.operatorName }}
                  <span class="badge badge-secondary">{{ entry.mode | camelToTitle }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
